import Cw8Create from "components/cw8/Cw8Create"

const CreateResources = () => {
  return (
    <Cw8Create
      resourceName = {'recursoInfografia'}
    ></Cw8Create>
  )
}

export default CreateResources